import React from 'react';
import Icon from '../../../components/AppIcon';

const ProjectStats = ({ stats }) => {
  const statItems = [
    {
      icon: 'Briefcase',
      value: stats?.totalProjects,
      label: 'Projetos Concluídos',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      icon: 'Users',
      value: stats?.happyClients,
      label: 'Clientes Satisfeitos',
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      icon: 'Star',
      value: `${stats?.averageRating}/5`,
      label: 'Avaliação Média',
      color: 'text-accent',
      bgColor: 'bg-accent/10'
    },
    {
      icon: 'Award',
      value: stats?.awards,
      label: 'Prêmios Recebidos',
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    },
    {
      icon: 'Clock',
      value: `${stats?.averageDuration} meses`,
      label: 'Tempo Médio',
      color: 'text-trust',
      bgColor: 'bg-trust/10'
    },
    {
      icon: 'Repeat',
      value: `${stats?.repeatClients}%`,
      label: 'Clientes Recorrentes',
      color: 'text-secondary',
      bgColor: 'bg-secondary/10'
    }
  ];

  return (
    <div className="bg-card rounded-2xl p-6 shadow-lg">
      <div className="flex items-center space-x-3 mb-6">
        <Icon name="BarChart3" size={24} color="var(--color-primary)" />
        <h3 className="font-playfair font-bold text-xl text-text-primary">
          Nossos Números
        </h3>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
        {statItems?.map((item, index) => (
          <div
            key={index}
            className="text-center p-4 rounded-xl bg-muted hover:shadow-md transition-shadow duration-200"
          >
            <div className={`w-12 h-12 ${item?.bgColor} rounded-full flex items-center justify-center mx-auto mb-3`}>
              <Icon name={item?.icon} size={20} className={item?.color} />
            </div>
            <p className={`text-2xl font-bold ${item?.color} mb-1`}>
              {item?.value}
            </p>
            <p className="text-text-secondary text-sm">
              {item?.label}
            </p>
          </div>
        ))}
      </div>
      {/* Additional Insights */}
      <div className="mt-6 pt-6 border-t border-border">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
          <div className="flex items-center space-x-2">
            <Icon name="TrendingUp" size={16} color="var(--color-success)" />
            <span className="text-text-secondary">
              <span className="font-semibold text-success">+25%</span> crescimento este ano
            </span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="MapPin" size={16} color="var(--color-primary)" />
            <span className="text-text-secondary">
              Atendemos <span className="font-semibold text-primary">São Paulo</span> e região
            </span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="Shield" size={16} color="var(--color-trust)" />
            <span className="text-text-secondary">
              <span className="font-semibold text-trust">5 anos</span> de garantia
            </span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="Leaf" size={16} color="var(--color-success)" />
            <span className="text-text-secondary">
              <span className="font-semibold text-success">100%</span> madeira sustentável
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectStats;